import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Flag, Icon, Popup, Header, Dropdown } from 'semantic-ui-react';
import cn from 'classnames';

import { Accounts, CustomAccount, AiToolset } from 'actions';
import { colors } from 'utils/colors';
import { notWealthica, getTickerSearchResult } from 'utils/helpers';
import {
  Modal,
  Message,
  Table,
  Button,
  Segment,
  Selection,
  SearchTicker,
} from 'components';
import { Quantity, CashAmount, ConfirmModal } from './components';

@withRouter
@connect((state) => ({
  customAcc: state.CustomAccount,
  account: state.CustomAccount.account,
  partnerName: state.Storage['partner-name'],
  user_region: state.Storage.user_region || 'CA',
}))
export default class BuildCustomAccount extends Component {
  state = {
    isOpen: false,
    conflictAccounts: null,
    resolveGicConflict: false,
    gicError: false,
  };

  componentWillMount() {
    const { dispatch, match, customAcc } = this.props;
    const { id } = match.params;

    if (
      Number(id) &&
      !Object.keys(customAcc.holdings).length &&
      !customAcc.gic_quantity &&
      !customAcc.gic_rate
    ) {
      return dispatch(CustomAccount.fetchId(id));
    }

    return false;
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const { match } = this.props;

    if (
      match.params.id === 'new' &&
      nextProps.account &&
      Number(nextProps.account.id)
    ) {
      return history.push(`/accounts/custom/${nextProps.account.id}`);
    }

    return false;
  }

  // componentDidUpdate(prevProps) {}

  getPriceFlag = (holding) => {
    const currency = {
      CAD: 'ca',
      USD: 'us',
    };

    // if security_detail does not exist, use yodlee currency for flag
    return holding.security_detail
      ? currency[holding.security_detail.default_currency]
      : currency[holding.default_currency];
  };

  getSearchParams = () => {
    const { account, user_region } = this.props;
    const types = [];
    const currency =
      user_region === 'CA' && account.currency === 'USD' ? 'USD' : '';
    const region = currency === 'USD' ? 'US' : user_region;
    return { region, types };
  };

  setResolveGicConflict = () =>
    this.setState({ resolveGicConflict: true }, this.saveBulk);

  round = (num) => Math.round(num * 100) / 100;

  createAccount = () => {
    const { name, institution, currency } = this.state;
    const { dispatch } = this.props;

    return dispatch(
      CustomAccount.createAccount({
        name,
        institution,
        currency,
        label: name,
        user_institution: institution,
      })
    );
  };

  saveBulk = () => {
    const { dispatch, customAcc, account, history } = this.props;
    const { gic_quantity, gic_rate, gic_ticker, gic_name } = customAcc;
    const { resolveGicConflict } = this.state;
    const gicFormat = /^GIC\d*:MKT$/;
    const getParams = () =>
      Object.keys(customAcc.holdings).reduce(
        (acc, key) => {
          if (!gicFormat.test(key)) {
            const { quantity } = customAcc.holdings[key];

            if (
              customAcc.holdings[key].security_detail.unadjusted_closing_price
                .CAD
            ) {
              acc.tickers += !acc.tickers.length ? `${key}` : `,${key}`;
              acc.quantities += !acc.quantities.length
                ? `${quantity}`
                : `,${quantity}`;
            }
          }

          return acc;
        },
        { tickers: '', quantities: '' }
      );
    const params = {
      account_id: account.id,
      cash_amount: customAcc.cash,
      ...(gic_quantity &&
        gic_rate &&
        gic_ticker && {
          gics: [
            {
              gic_quantity: gic_quantity.toString(),
              gic_rate: parseFloat((gic_rate / 100).toFixed(4)),
              gic_ticker,
              gic_name,
            },
          ],
        }),
      ...(resolveGicConflict && { resolve_gic_conflict: resolveGicConflict }),
      ...getParams(),
    };

    return dispatch(CustomAccount.saveBulk(params)).then((response) => {
      this.setState({ resolveGicConflict: false });

      if (response && response.type === 'CUSTOMACCOUNT_HOLDING_FAIL') {
        if (response.msg.split(' ')[0] === 'gic_rate') {
          const conflictAccounts = response.msg
            .substring(0, response.msg.length - 1)
            .split('[')[1]
            .split(', ');

          return this.setState({ isOpen: 'confirm', conflictAccounts });
        } else if (response.msg.split(' ')[0] === 'currency') {
          return this.setState({ gicError: 'Ticker' });
        } else if (response.msg.split(' ')[0] === 'Unique') {
          return this.setState({ gicError: 'Unique' });
        }
      }

      return history.push(`/accounts/${account.id}`);
    });
  };

  saveOnlyCash = () => {
    const { dispatch, customAcc, account, history } = this.props;

    dispatch(
      CustomAccount.saveBulk({
        account_id: account.id,
        cash_amount: customAcc.cash,
        quantities: '',
        tickers: '',
      })
    );
    dispatch(
      Accounts.edit(account.id, {
        cash: customAcc.cash,
        balance: customAcc.cash,
      })
    );

    return history.push(`/accounts/${account.id}`);
  };

  remove = (ticker) => {
    const { dispatch } = this.props;

    return dispatch(CustomAccount.remove(ticker));
  };

  removeAll = () => this.props.dispatch(CustomAccount.removeAll());

  isDisabled = () => {
    const { customAcc } = this.props;
    const { gic_ticker, gic_quantity, gic_rate } = customAcc;
    const gicFormat = /^GIC\d*:MKT$/;
    const hasGic = gic_ticker || gic_quantity || gic_rate;
    const hasHolding = Object.keys(customAcc.holdings).find(
      (ticker) => !gicFormat.test(ticker)
    );
    const holdingHasQuantity = Object.values(customAcc.holdings).reduce(
      (acc, val) => {
        if (val.security_detail.unadjusted_closing_price.CAD && !val.quantity) {
          acc = true;
        }
        return acc;
      },
      false
    );

    if (hasHolding && hasGic) {
      return (
        !(gic_ticker && gic_quantity && gic_rate) ||
        holdingHasQuantity ||
        !(customAcc.cash >= 0)
      );
    }
    if (hasHolding && hasGic) {
      return !(gic_ticker && gic_quantity && gic_rate) || holdingHasQuantity;
    }
    if (hasHolding) {
      return !(customAcc.cash >= 0) || holdingHasQuantity;
    }
    if (hasGic) {
      return (
        !(gic_ticker && gic_quantity && gic_rate) || !(customAcc.cash >= 0)
      );
    }
    if (hasHolding) {
      return holdingHasQuantity;
    }
    if (hasGic) {
      return !(gic_ticker && gic_quantity && gic_rate);
    }
    return !(customAcc.cash > 0);
  };

  closeModal = () =>
    this.setState({
      isOpen: false,
    });

  handleChange = (e) => {
    const { name, value } = e.target;

    return this.setState({ [name]: value });
  };

  handleGicChange = (e) => {
    const { name, value } = e.target;
    const { dispatch } = this.props;
    const num = Number(value);
    const limitRegex = /^\d*\.?\d*$/;
    const negative = !limitRegex.test(num);

    if (name === 'gic_ticker') {
      this.setState({ isOpen: false, gicError: false });
    }

    if (name === 'gic_rate') {
      this.setState({ isOpen: false });
    }

    if (negative) {
      if (name === 'gic_quantity' || name === 'gic_rate') {
        return dispatch(CustomAccount.updateGic(name, null));
      }
    }

    if (name === 'gic_quantity' || name === 'gic_rate') {
      if (name === 'gic_rate' && num > 100) {
        return dispatch(CustomAccount.updateGic(name, 100));
      } else if (!negative) {
        const rate =
          value === ''
            ? ''
            : Number.isInteger(num)
            ? num
            : value.split('.')[1].length >= 2
            ? Number(
                `${value.split('.')[0]}.${value.split('.')[1].substring(0, 2)}`
              )
            : num;

        return dispatch(CustomAccount.updateGic(name, rate));
      }
    } else if (name === 'gic_name' || name === 'gic_ticker') {
      return dispatch(CustomAccount.updateGic(name, value));
    }

    return false;
  };

  renderModal = (history, partnerName) => (
    <Modal basicTop open>
      <Modal.Header>
        <Header icon="book" content="Name New Portfolio" color="green" />
      </Modal.Header>
      <Modal.Content>
        <Field vb={notWealthica(partnerName)}>
          Institution:
          <input
            placeholder="(required)"
            name="institution"
            value={this.state.institution || ''}
            onChange={this.handleChange}
          />
        </Field>
        <Field vb={notWealthica(partnerName)}>
          Account type:
          <input
            placeholder="(required)"
            name="name"
            value={this.state.name || ''}
            onChange={this.handleChange}
          />
        </Field>
        <Field>
          Currency:
          <div style={{ width: '80%', float: 'right' }}>
            <StyledDropdown
              className={cn({ invalid: null })}
              placeholder="Currency"
              name="currency"
              selection
              options={[
                {
                  key: 'cad',
                  text: 'CAD',
                  value: 'CAD',
                  icon: <Flag name="ca" />,
                },
                {
                  key: 'usd',
                  text: 'USD',
                  value: 'USD',
                  icon: <Flag name="us" />,
                },
              ]}
              value={this.state.currency || ''}
              onChange={(e, data) => this.setState({ currency: data.value })}
              style={{ width: '95px' }}
            />
          </div>
        </Field>
      </Modal.Content>
      <Modal.Actions>
        <Button
          className="left"
          color={colors.red}
          icon="cancel"
          margin="0 0.5rem 0 0"
          onClick={() => history.push('/accounts/user')}
        >
          Cancel
        </Button>
        <Button
          className={cn(`left`, {
            loading: this.state.isLoading,
            disabled:
              !this.state.institution ||
              !this.state.name ||
              !this.state.currency,
          })}
          color={colors.green}
          icon="checkmark"
          onClick={this.createAccount}
        >
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );

  render() {
    const {
      history,
      match,
      customAcc,
      account,
      partnerName,
      user_region,
      dispatch,
    } = this.props;
    const { search } = customAcc;
    const { gic_ticker, gic_name, gic_quantity, gic_rate } = customAcc;
    const { isOpen, conflictAccounts, gicError } = this.state;
    const displayGicRate = gic_rate ? Number(gic_rate.toFixed(2)) : null;
    const gicFormat = /^GIC\d*:MKT$/;
    const hasGic = gic_ticker || gic_quantity || gic_rate;
    const excludeGicHoldings = Object.keys(customAcc.holdings).filter(
      (holding) => !gicFormat.test(holding)
    );
    const params = this.getSearchParams();

    if (match.params.id === 'new') {
      return this.renderModal(history, partnerName);
    }

    return (
      <Segment style={{ minHeight: '100%', textAlign: 'center' }}>
        <Header dividing size="large">
          {' '}
          {account.user_institution}{' '}
          <Flag name={account.currency === 'USD' ? 'us' : 'ca'} />
          <Header.Subheader>{account.label}</Header.Subheader>
        </Header>

        <Header size="medium" style={{ margin: '0' }}>
          Add Holdings
        </Header>

        <SearchTicker
          loading={customAcc.isFetching}
          results={getTickerSearchResult(search)}
          featureAction={CustomAccount}
          types={params.types}
          currency={params.region === 'US' ? 'USD' : ''}
        />

        <Note style={{ marginTop: '1rem' }}>
          {user_region === 'CA'
            ? account.currency === 'CAD'
              ? 'Currently, we have data for Canadian and US stocks/ETFs, Canadian mutual and segregated funds, and CAD/USD HISA funds.'
              : 'For USD accounts, we only have data for U.S.-listed stocks/ETFs, U.S. mutual funds, and Canadian-listed securities denominated in USD.'
            : 'Note: Currently we only have data for US-listed stocks and ETFs, and US mutual funds.'}
          <Popup
            trigger={
              <Icon
                name="question circle outline"
                style={{ fontSize: '15px', verticalAlign: 'initial' }}
              />
            }
            position="top center"
          >
            <Popup.Content>
              For mutual funds, use their fund code (e.g.{' '}
              {account.currency === 'CAD' ? 'TDB339' : 'VTSMX'}) if you have
              them to make sure you have the correct share class. If searching
              by name, do not include periods (e.g., put "US" instead of
              "U.S.").
            </Popup.Content>
          </Popup>
        </Note>
        {notWealthica(partnerName) &&
        !(
          account.provider !== 'uld' && excludeGicHoldings.length === 0
        ) ? null : (
          <div>
            <Note style={{ margin: '1rem' }}>
              Note: Use this <Link to="/tools/new-account-setup"> tool </Link>{' '}
              to calculate the number of shares to purchase if you are setting
              up a new portfolio.
            </Note>
          </div>
        )}

        <Segment className="basic compact" style={{ textAlign: 'left' }}>
          <Table
            textAlign="center"
            style={{ width: '25rem', marginBottom: '1rem' }}
          >
            <Table.Body>
              <Table.Cell
                width={2}
                style={{
                  background: 'rgba(245,93,90,0.2)',
                  fontWeight: '700',
                }}
              >
                Cash Amount&nbsp;
                <Popup
                  trigger={
                    <Icon
                      name="question circle outline"
                      style={{
                        fontSize: '15px',
                        verticalAlign: 'initial',
                        color: 'dimgrey',
                      }}
                    />
                  }
                  content="Non-interesting bearing."
                />
              </Table.Cell>
              <Table.Cell width={3} style={{ position: 'relative' }}>
                <div>
                  <CashAmount
                    value={customAcc.cash === undefined ? 0 : customAcc.cash}
                  />
                  <Flag
                    name={account.currency === 'USD' ? 'us' : 'ca'}
                    style={{ marginLeft: '0.3rem' }}
                  />
                </div>
              </Table.Cell>
            </Table.Body>
          </Table>
        </Segment>

        {!!excludeGicHoldings.length && (
          <Segment className="basic compact">
            <Table textAlign="center" style={{ marginBottom: '2rem' }}>
              <Table.Header>
                <Table.Row style={{ position: 'relative' }}>
                  <Popup
                    trigger={
                      <RemoveAll onClick={this.removeAll}>clear</RemoveAll>
                    }
                    wide
                    position="top center"
                    content="Clear all."
                  />

                  <Table.HeaderCell
                    style={{ background: 'rgba(245,93,90,0.2)' }}
                  >
                    Asset
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ background: 'rgba(245,93,90,0.2)' }}
                  >
                    Exchange
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ background: 'rgba(245,93,90,0.2)' }}
                  >
                    Class
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ background: 'rgba(245,93,90,0.2)' }}
                  >
                    Price
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ background: 'rgba(245,93,90,0.2)' }}
                  >
                    Quantity
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {Object.values(customAcc.holdings)
                  .reverse()
                  .map(
                    (holding) =>
                      !holding.gic_ticker && (
                        <StyledRow
                          negative={
                            !holding.security_detail.unadjusted_closing_price
                              .CAD
                          }
                          key={holding.security_detail.ticker}
                          style={{ height: 52 }}
                        >
                          <i
                            className="close"
                            onClick={() =>
                              this.remove(holding.security_detail.ticker)
                            }
                          >
                            +
                          </i>
                          <Table.Cell
                            style={{ position: 'relative' }}
                            width={5}
                          >
                            {holding.security_detail.ticker || 'N/A'}
                            <SecurityName>
                              {holding.security_detail.long_name || 'N/A'}
                            </SecurityName>
                            {!holding.security_detail.unadjusted_closing_price
                              .CAD && (
                              <Error>
                                <Popup
                                  trigger={
                                    <Icon
                                      style={{
                                        transform: 'translate(-20px, -4px)',
                                        position: 'absolute',
                                        display: 'block',
                                        marginTop: '0',
                                      }}
                                      name="exclamation circle"
                                    />
                                  }
                                  position="left center"
                                  content="Unfortunately, this security cannot be added as its price is $0"
                                />
                              </Error>
                            )}
                          </Table.Cell>
                          <Table.Cell>
                            {holding.security_detail.exchange_symbol || 'N/A'}
                          </Table.Cell>
                          <Table.Cell>
                            {holding.security_detail.global_asset_class ||
                              'N/A'}
                          </Table.Cell>
                          <Table.Cell>
                            $
                            {this.round(
                              holding.security_detail.unadjusted_closing_price[
                                holding.security_detail.default_currency
                              ] || 0
                            )}
                            <Flag
                              name={this.getPriceFlag(holding)}
                              style={{ marginLeft: '0.3rem' }}
                            />
                          </Table.Cell>

                          <Table.Cell
                            width={2}
                            style={{ position: 'relative' }}
                          >
                            {!!holding.security_detail.unadjusted_closing_price
                              .CAD ? (
                              <Quantity
                                field="quantity"
                                ticker={holding.security_detail.ticker}
                                value={holding.quantity}
                              />
                            ) : (
                              'N/A'
                            )}
                          </Table.Cell>
                        </StyledRow>
                      )
                  )}
              </Table.Body>
            </Table>
          </Segment>
        )}
        <div style={{ padding: '0 1rem', marginBottom: '1.5rem' }}>
          <div style={{ textAlign: 'left' }}>
            <Header style={{ fontSize: '14.72px', margin: '0' }}>
              {user_region === 'CA' ? 'Add GIC' : 'Add CD'}
              <Popup
                trigger={
                  <Icon
                    name="question circle outline"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                }
                position="top center"
                wide
              >
                <Popup.Content>
                  {user_region === 'CA'
                    ? 'This category is for fixed interest securities such as Guaranteed Investment Certificates (GICs).'
                    : 'This category is for fixed interest securities such as Certificates of Deposits (CDs) and term deposits (TDs).'}
                </Popup.Content>
              </Popup>
            </Header>
            <Header.Subheader
              style={{ color: 'rgba(0,0,0,0.5)', fontSize: '0.9rem' }}
            >
              (Optional)
            </Header.Subheader>
          </div>
          <GicField>
            <label>Value</label>
            <input
              className={cn({ invalid: null })}
              name="gic_quantity"
              type="number"
              placeholder="$"
              value={gic_quantity || ''}
              onChange={this.handleGicChange}
            />
            {(gic_rate || gic_ticker) && !gic_quantity ? (
              <ErrorLabel>Update value</ErrorLabel>
            ) : null}
          </GicField>
          <GicField>
            <label style={{ textAlign: 'left' }}>
              Interest Rate
              <br />
              <span style={{ color: 'rgba(0,0,0,0.5)', fontSize: '1rem' }}>
                (e.g., 0.75%)
              </span>
            </label>
            <input
              className={cn({ invalid: null })}
              name="gic_rate"
              type="number"
              placeholder="%"
              value={displayGicRate || ''}
              onChange={this.handleGicChange}
            />
            {(gic_quantity || gic_ticker) && !gic_rate ? (
              <ErrorLabel>Update interest rate</ErrorLabel>
            ) : null}
          </GicField>
          <GicField center>
            <label>
              Ticker
              <Popup
                trigger={
                  <Icon
                    name="question circle outline"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                }
                position="top center"
                wide
              >
                <Popup.Content>
                  For display in the Portfolio Scorecard. Note that you can
                  reuse this ticker in other accounts if the interest rate is
                  the same.
                </Popup.Content>
              </Popup>
            </label>
            <input
              className={cn({ invalid: null })}
              name="gic_ticker"
              placeholder={
                account.currency === 'CAD' ? 'e.g. GIC 1' : 'e.g. CD 1'
              }
              value={gic_ticker || ''}
              onChange={this.handleGicChange}
            />
            {(gic_quantity || gic_rate) && !gic_ticker ? (
              <ErrorLabel>Update ticker</ErrorLabel>
            ) : null}
          </GicField>
          <GicField center>
            <label>
              Name
              <Popup
                trigger={
                  <Icon
                    name="question circle outline"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                }
                position="top center"
                wide
              >
                <Popup.Content>
                  For display in the Portfolio Scorecard. Note that you can
                  reuse this ticker in other accounts if the interest rate is
                  the same.
                </Popup.Content>
              </Popup>
            </label>
            <input
              className={cn({ invalid: null })}
              name="gic_name"
              placeholder="(Optional)"
              value={gic_name || ''}
              onChange={this.handleGicChange}
            />
          </GicField>
        </div>
        {gicError === 'Ticker' && (
          <Message visible error style={{ margin: '0 auto', width: '400px' }}>
            <Icon
              name="exclamation circle"
              style={{ fontSize: '16px', transform: 'translateY(1px)' }}
            />
            This ticker has already been used in a{' '}
            {account.currency === 'USD' ? 'CAD' : 'USD'} account. Please enter a
            different ticker.
          </Message>
        )}
        {gicError === 'Unique' && (
          <Message visible error style={{ margin: '0 auto', width: '240px' }}>
            <Icon
              name="exclamation circle"
              style={{ fontSize: '16px', transform: 'translateY(1px)' }}
            />
            The limit is 10 GICs/HISAs.
          </Message>
        )}
        <Button
          style={{ marginTop: '2rem' }}
          className={cn('left centered grey-focus2', {
            disabled: this.isDisabled() || gicError,
            loading: customAcc.isFetching,
          })}
          color={colors.green}
          icon="line chart"
          onClick={() => {
            if (Object.keys(customAcc.holdings).length || hasGic) {
              this.saveBulk();
            } else {
              this.saveOnlyCash();
            }
            const key = `${
              account.id ? account.id : account.user_institution
            }::${true}`;
            const keyOverview = `Overview; All Accounts::${true}`;
            dispatch(AiToolset.removeAnalyzeScorecard(key));
            dispatch(AiToolset.removeAnalyzeScorecard(keyOverview));
          }}
        >
          Save
        </Button>
        <ConfirmModal
          account={account}
          accountList={this.props.accountList}
          close={this.closeModal}
          conflictAccounts={conflictAccounts}
          open={isOpen === 'confirm'}
          setResolveGicConflict={this.setResolveGicConflict}
        />
      </Segment>
    );
  }
}

BuildCustomAccount.propTypes = {
  dispatch: PropTypes.func,
  customAcc: PropTypes.object,
  account: PropTypes.object,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  partnerName: PropTypes.string,
  accountList: PropTypes.array,
  user_region: PropTypes.string,
};

BuildCustomAccount.defaultProps = {
  dispatch: () => null,
  customAcc: {},
  account: {},
  partnerName: '',
  accountList: [],
  user_region: 'CA',
};

const SecurityName = styled.div`
  font-size: 0.9rem;
  line-height: 1rem;
  color: ${(props) =>
    props.negative ? 'rgba(159,58,56, 0.6)' : 'rgba(0,0,0,0.5)'};
`;

const StyledRow = styled(({ className, children, ...rest }) => (
  <Table.Row className={className} {...rest}>
    {children}
  </Table.Row>
))`
  position: relative;

  .close {
    position: absolute;
    display: block;
    margin: -10px;
    margin-top: 20px;
    z-index: 100;
    transform: rotate(45deg);
    text-align: center;
    font-size: 1.7rem;
    font-style: normal;
    border-radius: 18px;
    height: 20px;
    width: 20px;
    line-height: 17px;
    padding: 0 1px;
    background: white;
    border: 1px solid #e4e5e5;
    color: black;
    cursor: pointer;
    transition: background 0.1s ease, border 0.1s ease;

    &:hover {
      background: #fff6f6;
      border: 1px solid #db2828;
    }
  }
`;

const RemoveAll = styled.div`
  position: absolute;
  top: 50%;
  left: -25px;
  transform: translateY(-50%);
  background: white;
  width: 50px;
  font-size: 0.9rem;
  border-radius: 10px;
  line-height: 20px;
  text-align: center;
  border: 1px solid #dededf;
  cursor: pointer;
  transition: border 0.2s ease;

  &:hover {
    border: 1px solid #db2828;
    background: #fff6f6;
  }
`;

const Error = styled.div`
  font-size: 1.7rem;
  position: absolute;
  top: 50%;
  left: -2.3rem;
  margin: -0.8rem auto;
  color: ${colors.red};
`;

const Field = styled.div`
  padding: 1rem 0 0 0;
  font-size: 1.14rem;
  line-height: 1.3em;
  border-bottom: 1px solid grey;
  padding: 0 0 1rem 0;
  &:last-child {
    padding: 1rem 0 0 0;
    border-bottom: unset;
  }

  &:nth-child(2) {
    padding: 1rem 0;
  }

  input {
    float: right;
    border: 0;
    background: transparent;
    width: 80%;
    color: rgba(0, 0, 0, 0.6);

    &:focus {
      outline: 0;
    }
  }
`;

const Note = styled.div`
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.5);
  margin: 0 auto;
`;

const StyledDropdown = styled(({ children, className, ...rest }) => (
  <Dropdown className={className} {...rest}>
    {children}
  </Dropdown>
))`
  height: 25px !important;
  min-height: unset !important;
  padding: 0.3rem !important;
  min-width: unset !important;
  &.invalid {
    border: 1px solid ${colors.red} !important;
    background: rgb(255, 240, 240) !important;
  }
  i {
    padding: 0.5rem !important;
  }
`;

const GicField = styled.fieldset`
  margin: 0.5rem 0;
  border: 0;
  padding: 0;
  position: relative;
  width: 100%;
  min-height: 32px;
  label {
    display: block;
    float: left;
  }
  input {
    position: absolute;
    left: calc(50% - 47px);
    padding: 0.4rem;
    border-radius: 3px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    transition: all 200ms ease;
    color: rgba(0, 0, 0, 0.8);
    width: 100%;
    max-width: 93px;
    font-size: 0.9rem;
    text-align: right;
    outline: none;
    &:focus,
    &:active {
      outline: none;
      border: 1px solid rgb(132, 183, 217);
      &::placeholder {
        color: rgba(0, 0, 0, 0.5);
      }
    }
    &::placeholder {
      color: rgba(0, 0, 0, 0.3);
      text-align: ${(props) => (props.center ? 'center' : 'right')};
    }
    &.invalid {
      border: 1px solid ${colors.red};
      background: rgb(255, 240, 240);
    }
  }
`;

const ErrorLabel = styled.div`
  position: absolute;
  white-space: nowrap;
  background-color: #fff;
  color: #db2828;
  border: 1px solid #db2828;
  font-size: 0.8rem;
  line-height: 1;
  padding: 11px 13px;
  font-weight: 700;
  z-index: 1;
  border-radius: 4px;
  left: calc(50% + 58px);
  text-transform: initial;

  &:not(.basic):before {
    content: '';
    position: absolute;
    z-index: 2;
    width: 8px;
    height: 8px;
    transform: translate(3%, 0) rotate(45deg);
    background: inherit;
    left: -5px;
    margin-top: -4px;
    top: 50%;
    border-width: 0 0 1px 1px;
    border-style: solid;
  }
`;
